/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marker_Import_Offset_LabelInputs */

const en_marker_import_offset_label = /** @type {(inputs: Marker_Import_Offset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offset by Project Incode`)
};

const fr_marker_import_offset_label = /** @type {(inputs: Marker_Import_Offset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decaler par l'incode du projet`)
};

const de_marker_import_offset_label = /** @type {(inputs: Marker_Import_Offset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offset durch Projekt Incode`)
};

const it_marker_import_offset_label = /** @type {(inputs: Marker_Import_Offset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offset di Project Incode`)
};

const ru_marker_import_offset_label = /** @type {(inputs: Marker_Import_Offset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Компенсация от Project Incode`)
};

const es_marker_import_offset_label = /** @type {(inputs: Marker_Import_Offset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compensación por código de proyecto`)
};

const zh_cn2_marker_import_offset_label = /** @type {(inputs: Marker_Import_Offset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项目编码偏移`)
};

const ja_marker_import_offset_label = /** @type {(inputs: Marker_Import_Offset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトインコードによるオフセット`)
};

const hi_marker_import_offset_label = /** @type {(inputs: Marker_Import_Offset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट इनकोड द्वारा ऑफसेट`)
};

const pt_pt2_marker_import_offset_label = /** @type {(inputs: Marker_Import_Offset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deslocamento por código de projeto`)
};

/**
* | output |
* | --- |
* | "Offset by Project Incode" |
*
* @param {Marker_Import_Offset_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const marker_import_offset_label = /** @type {((inputs?: Marker_Import_Offset_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marker_Import_Offset_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_marker_import_offset_label(inputs)
	if (locale === "de") return de_marker_import_offset_label(inputs)
	if (locale === "it") return it_marker_import_offset_label(inputs)
	if (locale === "ru") return ru_marker_import_offset_label(inputs)
	if (locale === "es") return es_marker_import_offset_label(inputs)
	if (locale === "zh-CN") return zh_cn2_marker_import_offset_label(inputs)
	if (locale === "ja") return ja_marker_import_offset_label(inputs)
	if (locale === "hi") return hi_marker_import_offset_label(inputs)
	if (locale === "pt-PT") return pt_pt2_marker_import_offset_label(inputs)
	return en_marker_import_offset_label(inputs)
});